import { rem } from 'polished'
import React, { useCallback, useContext, useRef } from 'react'
import styled from 'styled-components'
import { BasicTrip } from 'tripPlanner/types/common'
import { TripItem } from 'tripPlanner/types/tripItem'
import TripPlannerFloatingToggleButton from './TripPlannerFloatingToggleButton'
import DropdownList from 'components/Luxkit/Dropdown/List/DropdownList'
import noop from 'lib/function/noop'
import ModalContext from 'contexts/ModalContext'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import TripList from './TripList'
import { useIsMobileScreen } from 'hooks/useScreenSize'

const TripPlannerToggleContainer = styled.div`
  position: absolute;
  bottom: ${rem(28)};
  left: ${rem(12)};
`

export interface SelectedTrip {
  name: string,
  tripId?: string,
  items: Array<TripItem>
}

interface Props {
  trips: Array<BasicTrip>
  selectedTrip: SelectedTrip
  handleSelectTrip: (tripName: string, tripId?: string) => void
  dropDownVisible?: boolean
  toggleDropdownVisibility?: (e: React.MouseEvent<HTMLButtonElement> | undefined, overRideVal?: boolean) => void
  tripPlannerToggled?: boolean
  setTripPlannerToggled?: (val: boolean) => void
  hideAllTrips?: () => void
  className?: string;
}

function TripPlannerToggle({
  trips,
  selectedTrip,
  handleSelectTrip,
  dropDownVisible = false,
  toggleDropdownVisibility = noop,
  className,
}: Props) {
  const tripPlannerButtonRef = useRef<HTMLButtonElement>(null)

  const onClose = useCallback(() => {
    toggleDropdownVisibility(undefined, false)
  }, [toggleDropdownVisibility])

  const showModal = useContext(ModalContext)

  const handleShowMobileModal = useCallback(() => {
    showModal(
      <ModalBase>
        <ModalHeader title="Trips" />
        <ModalBody>
          <ModalContent>
            <TripList
              trips={trips}
              handleSelectTrip={handleSelectTrip}
              selectedTrip={selectedTrip}
            />
          </ModalContent>
        </ModalBody>
      </ModalBase>,
    )
  }, [handleSelectTrip, selectedTrip, showModal, trips])

  const isMobile = useIsMobileScreen()

  const onFloatingButtonClick = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    isMobile ? handleShowMobileModal() : toggleDropdownVisibility(e)
  }, [handleShowMobileModal, isMobile, toggleDropdownVisibility])

  return (
    <>
      <TripPlannerToggleContainer className={className}>
        <TripPlannerFloatingToggleButton
          onClick={onFloatingButtonClick}
          isOpen={dropDownVisible}
          ref={tripPlannerButtonRef}
        />
      </TripPlannerToggleContainer>
      <DropdownList
        size="S"
        open={dropDownVisible}
        placement="top-start"
        triggerRef={tripPlannerButtonRef}
        onClose={onClose}
        anchorRef={tripPlannerButtonRef}
      >
        <TripList
          trips={trips}
          handleSelectTrip={handleSelectTrip}
          selectedTrip={selectedTrip}
        />
      </DropdownList>
    </>

  )
}

export default TripPlannerToggle
